import { render, staticRenderFns } from "./ListingInvestments.vue?vue&type=template&id=5067d5bb&"
import script from "./ListingInvestments.vue?vue&type=script&lang=js&"
export * from "./ListingInvestments.vue?vue&type=script&lang=js&"
import style0 from "./ListingInvestments.vue?vue&type=style&index=0&id=5067d5bb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports